import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import Select from "react-select";
import { VARIABLES } from "../../Constant";
import secureLocalStorage from "react-secure-storage";

const CreateClientItemAssociation = () => {
    const userID = secureLocalStorage.getItem("userID");
    const delay_time = VARIABLES.delayTime;
    const navigate = useNavigate();

    // select dropdown
    const [item, setItem] = useState([]);
    const [client, setClient] = useState([]);

    const { useFetch } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data, isLoading } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { useCreate } = useAPIQuery({
        key: "client-item",
        endpoint: "/api/client-item-association/",
    });

    const handleCreateClientItemAssoc = (data) => {
        Swal.fire({
            title: "Client Item Association Created!",
            text: data.message,
            icon: "success",
        }).then((result) => {
            if (result.isConfirmed) {
                setTimeout(() => {
                    navigate(-1);
                }, 2000);
            }
        });
    };

    const handleErrorClientItemAssoc = (data) => {
        Swal.fire({
            title: "Error Creating Client Item Association",
            text: data?.data?.data?.message,
            icon: "error",
        });
    };

    const { mutate, isPending } = useCreate({
        onSuccess: handleCreateClientItemAssoc,
        onError: handleErrorClientItemAssoc,
        retry: 2,
    });

    // react Hook form Props
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
    } = useForm();

    // onSubmit handler to post form details
    const onSubmit = (data) => {
        var client_item = {
            item_id: data.item_id.value,
            client_id: data.client_id.value,
            created_by: userID,
            updated_by: userID,
        };

        mutate({
            data: client_item,
        });
    };

    useEffect(() => {
        if (data) {
            setItem(data.item);
            setClient(data.client);
        }
    }, [data]);

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title">
                            {" "}
                            Create Client Item Association{" "}
                        </h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-inner">
                        {/* For Form : Use React hook forms */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Client{" "}
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={client?.map((api) => {
                                                    return {
                                                        value: api.id,
                                                        label:
                                                            api?.first_name +
                                                            " " +
                                                            api?.last_name,
                                                    };
                                                })}
                                                isLoading={isLoading}
                                                isClearable={true}
                                                id="select-forms-client"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="client_id"
                                        control={control}
                                    />
                                    {errors.client_id && (
                                        <span className="fs-8 text-danger">
                                            Client Name is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Item{" "}
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={item?.map((api) => {
                                                    return {
                                                        value: api.id,
                                                        label: api?.item_name,
                                                    };
                                                })}
                                                isLoading={isLoading}
                                                isClearable={true}
                                                id="select-forms-item"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="item_id"
                                        control={control}
                                    />
                                    {errors.item_id && (
                                        <span className="fs-8 text-danger">
                                            Item Name is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-md btn-light me-2"
                                            id="submit-button-backbutton"
                                            onClick={() => navigate(-1)}
                                        >
                                            Back
                                        </button>
                                        {isPending ? (
                                            <button
                                                type="button"
                                                id="button-client-item-loading"
                                                className="btn btn-md text-dark"
                                                disabled
                                            >
                                                Loading...
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-md btn-primary"
                                                id="submit-button-client-item-supplier"
                                            >
                                                Create
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateClientItemAssociation;
